import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Input from '@mui/material/Input';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/VisibilityOutlined';
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';

import { checkSecurity } from 'components/config/Security';

import axios from 'api/axios';
import Login from './Login.js';
const LOGIN_URL = 'users/auth';

const Auth = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const from = location.state?.from?.pathname || '/accueil';

  const errRef = useRef();
  const userRef = useRef();

  const [pwd, setPwd] = useState('');
  const [user, setUser] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    checkSecurity(navigate);
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg('');
  }, [user, pwd]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const handleMouseUpPassword = (event) => event.preventDefault();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(LOGIN_URL,
        JSON.stringify({ email: user, password: pwd }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      setPwd('');
      setUser('');

      const userData = response?.data?.data;

      localStorage.setItem("email", user);
      localStorage.setItem("filter", null);
      localStorage.setItem("userID", userData?.id);
      localStorage.setItem("user", userData?.firstname);
      localStorage.setItem("lastname", userData?.lastname);
      localStorage.setItem("firstname", userData?.firstname);
      localStorage.setItem("accessToken", userData?.access_token);
      localStorage.setItem("isAuthenticated", true);

      navigate(from, { replace: true });
    } catch (err) {
      console.log(err);
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Invalid Username or Password');
      } else if (err.response?.status === 422) {
        setErrMsg('Invalid Username or Password');
      } else {
        setErrMsg('Login Failed');
      }
      errRef.current.focus();
    }
  }

  return (
    <Login>
      <div className="Login-formulaire">
        <form onSubmit={handleSubmit}>
          <div ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</div>
          <div className="Login-field identifier"><span>*</span> Email</div>
          <Input
            required
            value={user}
            inputRef={userRef}
            id="Login-identifier"
            disableUnderline={true}
            className="Login-input identifier"
            onChange={(e) => setUser(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <MailOutlineIcon fontSize="small" style={{ color: '#326ea0' }} />
              </InputAdornment>
            }
          />

          <div className="Login-field password"><span>*</span> Mot de passe</div>
          <Input
            required
            value={pwd}
            id="Login-password"
            disableUnderline={true}
            className="Login-input password"
            onChange={(e) => setPwd(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            startAdornment={
              <InputAdornment position="start">
                <LockOutlinedIcon fontSize="small" style={{ color: '#326ea0' }} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label={
                    showPassword ? 'cacher le mot de passe' : 'afficher le mot de passe'
                  }
                  onClick={handleClickShowPassword}
                  onMouseUp={handleMouseUpPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                </IconButton>
              </InputAdornment>
            }
          />

          <div className="Login-forgot-password"><a onClick={() => navigate('/renouvelerMotDePasse')}>Mot de passe oublié ?</a></div>
          <button className="Login-rectangle-button" onSubmit={handleSubmit}>Se connecter</button>
        </form>
      </div>
    </Login>
  );
}

export default Auth;
